// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enrollmentEnvironment: 'cert',
  urlSecutiry: true,
  apiURL: 'https://staging-panama-krediya-api-gateway-sfnpiy3jcq-ue.a.run.app/v1/',
  salesAPIURL: 'https://staging-panama-ventas-service-sfnpiy3jcq-ue.a.run.app/v1/',
  salesSiteURL: 'https://ventas-staging-panama-dot-smartcredit2.ue.r.appspot.com/',
  kycSiteURL: 'https://kyc-staging-dot-smartcredit2.ue.r.appspot.com/',
  incodeApiURL: 'https://demo-api.incodesmile.com/0/',
  logApiURL: 'https://staging-panama-logs-service-sfnpiy3jcq-ue.a.run.app/v1/',
  webPageStartToken: 'eyJzdG9yZV9pZCI6ICJjMjVmN2JlNy01MDdiLTRlMDctYWFlMy04NDI3MGYyMjQ1NDQiLCAic291cmNlIjogIndlYi1wYWdlIiwgImN1cnJlbnRfdG9rZW4iOiAiIn0=',
  oneMarketerLiveChatUrl: '',
  tokenKredicash: {
    online: 'eyJhbGciOiJIUzI1NiJ9.eyJzdG9yZV9pZCI6ImZmZjAyNTJjLTdkZDAtNDdlYy05NTAyLTQyNTUxYjg3NzhjOCIsInN1YiI6ImZmZjAyNTJjLTdkZDAtNDdlYy05NTAyLTQyNTUxYjg3NzhjOCIsImlhdCI6MTc0MTMxNDU5NywiZXhwIjo0ODk3MDc0NTk3fQ.FuKczyzXIrvw5oalksPUJwTmKuiKFkkYIlE8orj80ps',
    lukiApp: 'eyJhbGciOiJIUzI1NiJ9.eyJzdG9yZV9pZCI6ImZiZjYwYzdiLWQyMjktNDM2MC05MjI0LTA5MDEyZDY3OTQ0MCIsInN1YiI6ImZiZjYwYzdiLWQyMjktNDM2MC05MjI0LTA5MDEyZDY3OTQ0MCIsImlhdCI6MTc0MTMxNDU3NywiZXhwIjo0ODk3MDc0NTc3fQ.PqodObiCVZniy5WJcwHR3NZU11YM8tP9AczKBTArfoo',
    webPage: 'eyJzdG9yZV9pZCI6ICI2ZjExOGU5Yi1hMzZhLTQxM2ItYTYyOC1iMmI4NDE2ZjIwZTciLCAic291cmNlIjogIndlYi1wYWdlIiwgImN1cnJlbnRfdG9rZW4iOiAiIn0',
  },
  global: {
    country: {
      name: 'Panamá',
      code: 'PA',
      locale: 'es-PA',
      localeDate: null,
      currency: 'USD',
      timezone: '-0500',
      phoneCountryCode: '+507',
      phoneCountryMask: '+507 9999-9999',
      minPhoneNumberCharacters: 14,
      maxPhoneNumberCharacters: 14,
      minAmountRequestCommissionPayment: 0,
      showPrequalifiedButton: false,
      documentTypeOptions: [
        { label: 'Cédula Nacional', value: 'cedula-nacional'},
        { label: 'Cédula de Extranjería', value: 'cedula-extranjeria'},
        { label: 'Pasaporte / Carnet de Residencia', value: 'pasaporte-residencia'},
      ],
      customerServicePhone: '+507 6227-4818',
      customerServiceKredicashPhone: '+507 6846-7698',
      socialMedia : {
        instagram: "https://instagram.com/krediyapanama",
        facebook: "https://www.facebook.com/Krediyapanama",
        linkedin : "https://www.linkedin.com/company/krediya",
      },
      bankList: [
        { name: 'Allbank Corp'},
        { name: 'BAC International Bank, Inc.'},
        { name: 'Balboa Bank & Trust Corp'},
        { name: 'Banco Aliado S.A.'},
        { name: 'Banco Azteca (Panamá), S.A.'},
        { name: 'Banco BAC de Panamá, S.A.'},
        { name: 'Banco Bolivariano (Panamá), S.A.'},
        { name: 'Banco Citibank (Panamá,) S.A.'},
        { name: 'Banco Davivienda (Panamá) S.A.'},
        { name: 'Banco de Bogotá, S.A.'},
        { name: 'Banco del Pacífico (Panamá), S.A.'},
        { name: 'Banco Delta, S.A.'},
        { name: 'Banco Ficohsa (Panamá), S.A.'},
        { name: 'Banco G&T Continental (Panamá) S.A. (BMF)'},
        { name: 'Banco HIPOTECARIO NACIONAL'},
        { name: 'Banco General, S.A.'},
        { name: 'Banco Internacional de Costa Rica, S.A (BICSA)'},
        { name: 'Banco La Hipotecaria, S.A.'},
        { name: 'Banco Lafise Panamá S.A.'},
        { name: 'Banco Latinoamericano de Comercio Exterior, S.A. (BLADEX)'},
        { name: 'Banco Nacional de Panamá'},
        { name: 'Banco Panamá, S.A'},
        { name: 'Banco Panameño de la Vivienda, S.A. (BANVIVIENDA)'},
        { name: 'Banco Pichincha Panamá, S.A.'},
        { name: 'Banco Prival, S.A. (Español) o Prival Bank, S.A. (en inglés)'},
        { name: 'Banco Universal, S.A.'},
        { name: 'Bancolombia S.A.'},
        { name: 'Banesco S.A.'},
        { name: 'BANISI, S.A.'},
        { name: 'Banistmo S.A.'},
        { name: 'Bank Leumi-Le Israel B.M.'},
        { name: 'Bank of China Limited'},
        { name: 'BBP Bank S.A.'},
        { name: 'BCT Bank International S.A.'},
        { name: 'Caja de Ahorros'},
        { name: 'Capital Bank Inc.'},
        { name: 'Citibank, N.A. Sucursal Panamá'},
        { name: 'Credicorp Bank S.A.'},
        { name: 'FPB Bank Inc.'},
        { name: 'Global Bank Corporation'},
        { name: 'Korea Exchange Bank, Ltd.'},
        { name: 'Mega International Commercial Bank Co. Ltd.'},
        { name: 'Mercantil Bank (Panamá), S.A.'},
        { name: 'Metrobank, S.A.'},
        { name: 'MiBanco, S.A.BMF'},
        { name: 'MMG Bank Corporation'},
        { name: 'Multibank Inc.'},
        { name: 'Produbank (Panamá) S.A.'},
        { name: 'St. Georges Bank & Company, Inc.'},
        { name: 'The Bank of Nova Scotia (Panamá), S.A.'},
        { name: 'The Bank of Nova Scotia (SCOTIABANK)'},
        { name: 'Towerbank International Inc.'},
        { name: 'Unibank, S.A.'},
      ]
    },
    appKrdyaStoreId: 'c25f7be7-507b-4e07-aae3-84270f224544',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
